export const INTRODUCES = [
  {
    title: '카운트핏 트레이너 앱을 다운받고\n자신의 PT회원을 연결하세요.',
    description: "트레이너는 '카운트핏 트레이너' 앱을, PT회원은 '카운트핏' 앱을 다운 받으세요. 이후 앱을 통해 서로 연결하고 운동목표 설정, PT수업 일수 체크, PT일지 작성/전송 등 한차원 높은 회원 관리를 시작해 보세요.",
  },
  {
    title: '연결된 회원에게는 카운트핏 운동인식밴드가 배송됩니다.',
    description:
      '카운트핏을 통해 연결된 트레이너의 PT회원에게는 PT회원의 주소 또는 PT트레이너가 일하는 헬스장 주소로 최신 디지털 기술의 운동인식밴드를 배송해 드립니다. <br/>(유료 구독기간 동안 대여 형태로 제공하며 구독이 종료되면 택배사를 통해 회수합니다.)',
  },
  {
    title: '운동인식밴드가 회원의 운동을 \n자동으로 인식하고 기록해줍니다.',
    description:
      '운동인식밴드는 회원이 집 또는 헬스장에서 트레이너 없이 개인운동을 할때 사용되며 카운트핏 앱과 연동하여 올바르게 수행된 운동만 정확히 인식하고 자동으로 횟수를 세어줍니다.',
  },
  {
    title: '자동 생성된 운동일지가 \n회원과 트레이너에게 실시간 공유됩니다.',
    description:
      '운동인식밴드가 카운트한 운동의 종류/세트수/수행횟수/무게 등의 정보가 근육 부위와 함께 실시간 자동으로 기록되며 이를 바탕으로 운동일지가 트레이너와 회원의 앱에 자동으로 생성 및 공유 됩니다.',
  },
  {
    title: '운동일지를 바탕으로 \n각 회원별 운동루틴을 카운트핏 앱에서 만들어 보세요.',
    description:
      '작성된 PT일지 또는 카운트핏의 운동 라이브러리를 이용해서 손쉽게 회원별 운동루틴를 만들어보세요. 트레이너님의 전문적인 운동루틴을 터치 몇번으로 디지털화 하고 이를 운동미션으로 활용해 보세요.',
  },
  {
    title: '운동미션을 회원에게 전송하고 회원이 운동을 하는지 \n실시간 밀착관리를 해보세요.',
    description:
      '단순히 수업만 해주는 트레이너에서 수업을 바탕으로 운동미션까지 만들어주는 트레이너로 경쟁력을 강화하세요. 그리고 운동인식밴드를 통해 운동 수행 여부까지 체크하는 한차원 높은 밀착관리를 실현하세요.',
  },
  {
    title: '수업이 없는 날에도 꾸준히 운동을 한 회원을 찾아서 \n할인 또는 보너스 등의 보상을 제공해 보세요.',
    description:
      '막연하고 예측이 어려운 ‘목표 체지방율 달성시 페이백’과 같은 보상 프로그램은 모객효과가 없다는 것을 아시나요? <br/>카운트핏 서비스를 통해 운동 미션 달성 횟수와 같은 구체적인 기록으로 보상을 제공하세요.<br/>신규회원 등록은 물론 기존회원 재등록시에도 운동 수행 기반 보상 프로그램으로 등록률을 높여보세요!',
  },
];
